// Support ticket navigation helpers (category prefill via query param).

export const SUPPORT_TICKET_TYPES = ["contact", "issue"];

export const SUPPORT_ISSUE_CATEGORY_KEYS = [
  "payment",
  "withdrawal",
  "calls",
  "messages",
  "verification",
  "report",
  "technical",
  "other",
];

/** Map legacy/alias slugs to canonical category keys. */
const CATEGORY_ALIASES = {
  withdraw: "withdrawal",
  payouts: "withdrawal",
  payout: "withdrawal",
  verify: "verification",
  identity: "verification",
  report_abuse: "report",
  abuse: "report",
  safety: "report",
};

/**
 * Resolve a raw category slug to a valid issue category key, or "" if invalid.
 */
export function resolveSupportCategory(raw) {
  if (raw == null) return "";

  const normalized = String(raw).trim().toLowerCase().replace(/-/g, "_");
  if (!normalized) return "";

  const mapped = CATEGORY_ALIASES[normalized] || normalized;
  return SUPPORT_ISSUE_CATEGORY_KEYS.includes(mapped) ? mapped : "";
}

/**
 * Build path for SupportNewTicketPage.
 * @param {{ type?: "contact" | "issue", category?: string }} options
 */
export function buildSupportNewTicketPath({ type = "issue", category } = {}) {
  const safeType = type === "contact" ? "contact" : "issue";
  const resolved = resolveSupportCategory(category);

  if (resolved) {
    const params = new URLSearchParams({ category: resolved });
    return `/support/new/${safeType}?${params.toString()}`;
  }

  return `/support/new/${safeType}`;
}

/**
 * When :type route param is a legacy slug (e.g. /support/new/verification),
 * return the matching category; otherwise "".
 */
export function resolveSupportCategoryFromRouteType(typeParam) {
  const type = String(typeParam || "").trim().toLowerCase();
  if (!type || SUPPORT_TICKET_TYPES.includes(type)) return "";
  return resolveSupportCategory(type);
}
